import { render, staticRenderFns } from "./ModalChild.vue?vue&type=template&id=472d20b0&scoped=true&"
import script from "./ModalChild.vue?vue&type=script&lang=js&"
export * from "./ModalChild.vue?vue&type=script&lang=js&"
import style0 from "./ModalChild.vue?vue&type=style&index=0&id=472d20b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472d20b0",
  null
  
)

export default component.exports